import React from 'react';
import style from './NoRange.module.scss';

const NoRange = () => {
	return <h4 className={style.headline}>Aucune plage saisie</h4>;
};

export default NoRange;
